import $ from 'jquery';

$(_ => {

  const $select = $('#calendar-select-month');
  if ($select.length === 0) return;

  $select.on('change', event => {

    var selectedCats = $checks.filter(':checked').toArray().map(e => $(e).val());
    var locationURL = $(event.target).val();

    if(selectedCats.length > 0){
      locationURL += "?categories=" + selectedCats.toString();
    }

    window.location.href = locationURL;
  });

  const $checks = $('.js-checkbox-cal-filter-prod-cat');
  const dates = [];

  $(document).ready(function(){
    updateCalendarData();
  });

  $('.js-cal-date').each((index, date) => {
    const $date = $(date);
    const prods = [];

    $date.find('.js-cal-prod').each((index, prod) => {
      const $prod = $(prod);
      const cat = $prod.attr('data-prod-cat');
      prods.push({ el: prod, cat });
    });

    dates.push({el: date, prods});
  });

  $checks.on('change', _ => {
    updateCalendarData();
  });

  function updateCalendarData(){
    const activeCats = $checks.filter(':checked').toArray().map(e => $(e).val());

    const toShow = [];
    const toHide = [];

    for (const date of dates) {
      let dateVisible = false;
      for (const prod of date.prods) {
        if (activeCats.includes(prod.cat)) {
          toShow.push(prod.el);
          dateVisible = true;
        } else {
          toHide.push(prod.el)
        }
      }
      (dateVisible ? toShow : toHide).push(date.el);
    }

    // Update the month links at the bottom of the calendar with the new category filter data

    var catsString = activeCats.toString();

    if(catsString !== ""){

      if($("#js-cal-month-prev").length > 0){
        var $prevLink = $("#js-cal-month-prev").attr("href");

        if($prevLink.includes("?categories=")){
          $prevLink = $prevLink.split('?categories=')[0];
        }

        $prevLink = $prevLink + "?categories=" + catsString;

        $("#js-cal-month-prev").attr("href", $prevLink);

      }

      if($("#js-cal-month-next").length > 0){
        var $nextLink = $("#js-cal-month-next").attr("href");

        if($nextLink.includes("?categories=")){
          $nextLink = $nextLink.split('?categories=')[0];
        }

        $nextLink = $nextLink + "?categories=" + catsString;

        $("#js-cal-month-next").attr("href", $nextLink);

      }

    }

    window.requestAnimationFrame(_ => {
      $(toShow).removeClass('filter-hidden');
      $(toHide).addClass('filter-hidden');
    });
  }

});